import * as firebase from "firebase/app";

import "firebase/auth";
import "firebase/firestore";
import "firebase/functions";
import "firebase/storage";


import Config from "../Config/Config";
import FirebaseAuthService from "./auth/FirebaseAuthService";
import FirestoreService from "shared/services/firebase/FirestoreService";

const config = {
  apiKey: Config.firebaseApiKey(),
  authDomain: Config.firebaseAuthDomain(),
  databaseURL: Config.firebaseRealtimeDbUrl(),
  projectId: Config.firebaseProjectId(),
  storageBucket: Config.firebaseStorageBucket(),
  messagingSenderId: Config.firebaseMessagingSenderId()
};

firebase.initializeApp(config);
firebase.functions();
const firestore = firebase.firestore();

if (Config.isLocal()) {
  console.log("Running with emulators")
  firebase.functions().useFunctionsEmulator("http://localhost:5001");
  firebase.firestore().settings({ host: Config.firebaseFirestoreEmulatorHost(), ssl: false });
}

FirebaseAuthService.observeAuthChanges();

FirestoreService.firestore = firestore;

export default class FirebaseService {}



// WEBPACK FOOTER //
// ./src/services/firebase/FirebaseService.ts